import { Box } from "@mui/system";
import AboutUsComponent from "../../components/AboutUsComponent/AboutUs";
import DashboardLayout from "../../Layout/DashboardLayout/DashboardLayout";
import { Helmet } from "react-helmet";
import TagManager from "react-gtm-module";
import { useEffect } from "react";
import AboutUsComponentV2 from "../../components/AboutUsComponent/AboutUsComponentV2";

const AboutUs = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "G-VWGPB9LR1K", // Replace with your Google Tag Manager ID
      dataLayerName: "PageDataLayer",
      dataLayer: {
        page: window.location.pathname,
      },
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <>
      <Helmet>
        <title>About Marcel Equipment | Leaders in Used Heavy Equipment</title>
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <meta
          name="description"
          content="Discover Marcel Equipment’s commitment to quality, offering reliable used, rebuilt, and reconditioned construction and landfill equipment to meet your needs."
        />
      </Helmet>
      <DashboardLayout activeTab={"AboutUs"}>
        {/* <Box className="container">
          <Box className="p-x-20 p-b-50">
            <AboutUsComponent />
          </Box>
        </Box> */}
        <AboutUsComponentV2 />
      </DashboardLayout>
    </>
  );
};
export default AboutUs;
